var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail-page',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"title"})]},proxy:true},{key:"content",fn:function(){return [_c('tab-list')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }